// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    padding: none;
  }
  
  body {
    color: #658c5d;
    text-align: center;
    /* padding: 50px; */
    
    font: 14px "Elza", Helvetica, Arial, sans-serif;
  }
  
  footer {
    /* margin: 10px; */
  }
  
  h1 {
    font-family: "Gelica",'Times New Roman', Times, serif;
    font-size: 24px;
    color: #2c3387;
    text-align: left;
  }

  #subtitle {
    color: #ff00ff;
    font-family: "Elza", Helvetica, Arial, sans-serif;
    font-style: italic;
  }
  
  h2 {
    color: #2c3387;
    font-family: "Gelica", 'Times New Roman', Times, serif;
    text-align: left;
  }
  
  h3 {
    color: #658c5d;
    /* font-family: "Gelica", 'Times New Roman', Times, serif; */
    font-family: "variex", 'Times New Roman', Times, serif;
    text-align: left;
    font-size: 36px;
  }


  
  a {
    color: #00B7FF;
    text-decoration: none;
  }
  
  a:hover {
    color: #ff00ff;
  }
  
  #title {
    z-index: 1;
    position: absolute;
    left: 2vw;
    top: 2vh;
    /* margin-left: 3vw; */
  }
  
  #title-text {
    display: absolute;
    left: 2vw;
    font-size: 24px;
    font-weight: bolder;
  }

  #title-heading {
    position: absolute;
    bottom: 2vh;
    left: 2vw;
    font-size: 24px;
  }
  
  select {
    background-color: white;
    border-radius: 5px;
    color: #658c5d;
    border: 1px solid #658c5d;
    /* padding: 5px; */
    text-align: center;
    font-family: "Elza Light", Helvetica, Arial, sans-serif;
  }
  
  input {
    background-color: white;
    border-radius: 5px;
    color: #658c5d;
    border: 1px solid #658c5d;
    width: 5vw;
    padding: 6px;
    margin-left: 100px;
    margin-right: 10px; 
  }
  
  .sources {
    text-align: left;
  }
  
  
  .page-link:hover {
    color: yellow;
    cursor: grab;
  }

  .page-link {
    color: #658c5d;
    width: 20px;
  }
  
  .projection-input {
    text-align: center;
    /* margin-left: auto;
    margin-right: auto; */
    padding: 10px;
  }
  
  /* start  */
  #left {
    position: relative;
    width: 35vw;
    height: 100vh;
    /* overflow: hidden; */
    float: left;
  }
  #right {
    position: relative;
    width: 65vw;
    height: 100vh;
    overflow: hidden;
    float: left;
  }

  #map-projections {
    width: 100%;
    position: relative;
  }
  
  #map-projection-text {
    /* width: 100%; */
    padding-right: 8%;
    padding-left: 15%;
    padding-top: 5vh;
    position: relative;
  }
  /* end */
  
  #source-code {
    position: absolute;
    bottom: 5vh;
    right: 5vh;
    z-index: 1;
  }
  `, "",{"version":3,"sources":["webpack://./src/MainPage/MainPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;;IAEnB,+CAA+C;EACjD;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qDAAqD;IACrD,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,iDAAiD;IACjD,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,sDAAsD;IACtD,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,4DAA4D;IAC5D,sDAAsD;IACtD,gBAAgB;IAChB,eAAe;EACjB;;;;EAIA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,uDAAuD;EACzD;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB;yBACqB;IACrB,aAAa;EACf;;EAEA,WAAW;EACX;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;EACA,QAAQ;;EAER;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;EACZ","sourcesContent":["html {\n    padding: none;\n  }\n  \n  body {\n    color: #658c5d;\n    text-align: center;\n    /* padding: 50px; */\n    \n    font: 14px \"Elza\", Helvetica, Arial, sans-serif;\n  }\n  \n  footer {\n    /* margin: 10px; */\n  }\n  \n  h1 {\n    font-family: \"Gelica\",'Times New Roman', Times, serif;\n    font-size: 24px;\n    color: #2c3387;\n    text-align: left;\n  }\n\n  #subtitle {\n    color: #ff00ff;\n    font-family: \"Elza\", Helvetica, Arial, sans-serif;\n    font-style: italic;\n  }\n  \n  h2 {\n    color: #2c3387;\n    font-family: \"Gelica\", 'Times New Roman', Times, serif;\n    text-align: left;\n  }\n  \n  h3 {\n    color: #658c5d;\n    /* font-family: \"Gelica\", 'Times New Roman', Times, serif; */\n    font-family: \"variex\", 'Times New Roman', Times, serif;\n    text-align: left;\n    font-size: 36px;\n  }\n\n\n  \n  a {\n    color: #00B7FF;\n    text-decoration: none;\n  }\n  \n  a:hover {\n    color: #ff00ff;\n  }\n  \n  #title {\n    z-index: 1;\n    position: absolute;\n    left: 2vw;\n    top: 2vh;\n    /* margin-left: 3vw; */\n  }\n  \n  #title-text {\n    display: absolute;\n    left: 2vw;\n    font-size: 24px;\n    font-weight: bolder;\n  }\n\n  #title-heading {\n    position: absolute;\n    bottom: 2vh;\n    left: 2vw;\n    font-size: 24px;\n  }\n  \n  select {\n    background-color: white;\n    border-radius: 5px;\n    color: #658c5d;\n    border: 1px solid #658c5d;\n    /* padding: 5px; */\n    text-align: center;\n    font-family: \"Elza Light\", Helvetica, Arial, sans-serif;\n  }\n  \n  input {\n    background-color: white;\n    border-radius: 5px;\n    color: #658c5d;\n    border: 1px solid #658c5d;\n    width: 5vw;\n    padding: 6px;\n    margin-left: 100px;\n    margin-right: 10px; \n  }\n  \n  .sources {\n    text-align: left;\n  }\n  \n  \n  .page-link:hover {\n    color: yellow;\n    cursor: grab;\n  }\n\n  .page-link {\n    color: #658c5d;\n    width: 20px;\n  }\n  \n  .projection-input {\n    text-align: center;\n    /* margin-left: auto;\n    margin-right: auto; */\n    padding: 10px;\n  }\n  \n  /* start  */\n  #left {\n    position: relative;\n    width: 35vw;\n    height: 100vh;\n    /* overflow: hidden; */\n    float: left;\n  }\n  #right {\n    position: relative;\n    width: 65vw;\n    height: 100vh;\n    overflow: hidden;\n    float: left;\n  }\n\n  #map-projections {\n    width: 100%;\n    position: relative;\n  }\n  \n  #map-projection-text {\n    /* width: 100%; */\n    padding-right: 8%;\n    padding-left: 15%;\n    padding-top: 5vh;\n    position: relative;\n  }\n  /* end */\n  \n  #source-code {\n    position: absolute;\n    bottom: 5vh;\n    right: 5vh;\n    z-index: 1;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
